<template>
  <div class="product-group">
    <div class="container fr-aic fr-jcsb">
      <comp-tab :data="[{ label: '使用中', value: 2 }, { label: '已停用', value: 1 }]" v-model="query.ishidden" />
    </div>

    <div class="container">
      <el-row gutter="8">
        <el-col span="4">
          <el-input placeholder="输入名称搜索" prefix-icon="el-icon-search" size="small" v-model="query.containsname"></el-input>
        </el-col>
        <el-col span="4">
          <el-button @click="onSearch" size="small">搜索</el-button>
        </el-col>
        <el-col class="fr-jcfe" offset="12" span="4">
          <el-button @click="showDialog = true" size="small" type="primary">新建分组</el-button>
        </el-col>
      </el-row>
    </div>

    <div class="container" id="table">
      <el-table :data="categories" border ref="table" style="width: 100%">
        <el-table-column align="center" class="table-column" header-align="center" width="46px">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.toptime !== 0 ? '取消置顶' : '点击分类置顶(小程序显示:最后推荐的在最上面)'" effect="dark" placement="top-start">
              <i
                :class="[
                  'el-icon-star-on',
                  {
                    show: scope.row.toptime > 0
                  }
                ]"
                :style="{ color: scope.row.toptime !== 0 ? '#e87b26' : 'grey' }"
                @click="onClickRecommend(scope.row)"
              ></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" label="id" prop="id" width="50px" />
        <el-table-column label="分组名称" width="300">
          <template slot-scope="scope">
            <div class="category-wrapp">
              <upload-file :limit="1" @success="update(scope.row)" height="50px" v-model="scope.row.image" width="50px"></upload-file>
              <div style="margin-left: 20px;">{{ scope.row.name.slice(1).split('/')[0] }} - {{ scope.row.name.slice(1).split('/')[1] }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="商品数" prop="productcount" />
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{ new Date(scope.row.createdat * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="onEditCategory(scope.row)" size="small" type="text">编辑</el-button>
            <el-button @click="onRestoreCategory(scope.row)" size="small" type="text" v-if="scope.row.hidden === 1">启用</el-button>
            <el-button @click="onHiddenCategory(scope.row)" size="small" type="text" v-if="scope.row.hidden === 0">停用</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 添加分类弹框 -->
    <el-dialog :visible.sync="showDialog" title="新建分类" width="500px">
      <el-form label-width="100px" ref="form" size="small">
        <el-form-item label="分类图">
          <upload-file :limit="1" height="120px" v-model="addForm.image" width="120px"></upload-file>
        </el-form-item>
        <el-form-item label="一级分类名">
          <el-col span="20">
            <el-input v-model="addForm.name1"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="二级分类名">
          <el-col span="20">
            <el-input v-model="addForm.name2"></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div class="dialog-footer fr-jcfs" slot="footer">
        <el-button @click="onAdd" size="small" type="primary">保存</el-button>
      </div>
    </el-dialog>

    <!--  编辑分类弹框 -->
    <el-dialog :visible.sync="showEditCategory" title="编辑分类" width="500px">
      <el-form label-width="100px" ref="form" size="small">
        <el-form-item label="分类图">
          <upload-file :limit="1" height="120px" v-model="editForm.image" width="120px"></upload-file>
        </el-form-item>
        <el-form-item label="一级分类名">
          <el-col span="20">
            <el-input v-model="editForm.name1"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="二级分类名">
          <el-col span="20">
            <el-input v-model="editForm.name2"></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div class="dialog-footer fr-jcfs" slot="footer">
        <el-button @click="onUpdate" size="small" type="primary">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import uploadFile from '../../components/uploadFile/index.vue';
import Tab from '../../components/tab/index.vue';
import { M } from '../../service/grpc.js';
import { rpc } from '../../service/index.js';
import { getToken } from '../../service/helper.js';

export default {
  components: {
    'comp-tab': Tab,
    'upload-file': uploadFile
  },
  data() {
    return {
      showDialog: false,
      showEditCategory: false,
      categories: [],
      query: {
        ishidden: 2,
        containsname: '',
        level: 2,
        count: 100,
        sortby: 2,
      },
      addForm: {
        name1: '',
        name2: '',
        image: '',
        hidden: 0
      },
      editForm: {},
      token: ''
    };
  },
  watch: {
    'query.ishidden': function() {
      rpc(
        'StoreCategoryService.GetCategoryList',
        M('CategoryListQueryRequest', {
          ...this.query,
          token: M('Token', { token: this.token })
        })
      ).then(res => {
        this.categories = res.categorylistList;
      });
    }
  },
  created() {
    this.token = getToken();

    rpc(
      'StoreCategoryService.GetCategoryList',
      M('CategoryListQueryRequest', {
        ...this.query,
        token: M('Token', { token: this.token })
      })
    ).then(res => {
      this.categories = res.categorylistList;
    });
  },
  methods: {
    onAdd() {
      this.addForm.name1 = this.addForm.name1.replace(/\//g, '');
      this.addForm.name2 = this.addForm.name2.replace(/\//g, '');
      if (!this.addForm.name1 || !this.addForm.name2) {
        this.$message({
          message: '分类名不可为空',
          type: 'error'
        });
        return;
      }
      this.addForm.name = `/${this.addForm.name1}/${this.addForm.name2}`;
      rpc(
        'StoreCategoryService.CreateCategory',
        M('CategoryWithTokenRequest', {
          token: M('Token', { token: this.token }),
          category: M('Category', {
            ...this.addForm,
            hidden: 0
          })
        })
      ).then(res => {
        this.categories.splice(0, 0, res);
        this.addForm = {
          name1: '',
          name2: '',
          image: '',
          hidden: 0
        };
        this.showDialog = false;
      });
    },

    update(row) {
      rpc(
        'StoreCategoryService.UpdateCategory',
        M('CategoryWithTokenRequest', {
          token: M('Token', { token: this.token }),
          category: M('Category', row)
        })
      ).then(res => {
        this.categories.splice(this.categories.findIndex(v => v.id === res.id), 1, res);
      });
    },

    onUpdate() {
      this.editForm.name1 = this.editForm.name1.replace(/\//g, '');
      this.editForm.name2 = this.editForm.name2.replace(/\//g, '');
      if (!this.editForm.name1 || !this.editForm.name2) {
        this.$message({
          message: '分类名不可为空',
          type: 'error'
        });
        return;
      }
      this.editForm.name = `/${this.editForm.name1}/${this.editForm.name2}`;
      rpc(
        'StoreCategoryService.UpdateCategory',
        M('CategoryWithTokenRequest', {
          token: M('Token', { token: this.token }),
          category: M('Category', this.editForm)
        })
      ).then(res => {
        this.categories.splice(this.categories.findIndex(v => v.id === res.id), 1, res);
        this.showEditCategory = false;
      });
    },

    onEditCategory(category) {
      var o = JSON.parse(JSON.stringify(category));
      this.editForm = {
        ...o,
        name1: o.name.slice(1).split('/')[0],
        name2: o.name.slice(1).split('/')[1]
      };
      this.showEditCategory = true;
    },

    onHiddenCategory(row) {
      row = JSON.parse(JSON.stringify(row));
      row.hidden = 1;
      rpc(
        'StoreCategoryService.UpdateCategory',
        M('CategoryWithTokenRequest', {
          token: M('Token', { token: this.token }),
          category: M('Category', row)
        })
      ).then(res => {
        this.categories.splice(this.categories.findIndex(v => v.id === res.id), 1, res);
      });
    },

    onRestoreCategory(row) {
      row = JSON.parse(JSON.stringify(row));
      row.hidden = 0;
      rpc(
        'StoreCategoryService.UpdateCategory',
        M('CategoryWithTokenRequest', {
          token: M('Token', { token: this.token }),
          category: M('Category', row)
        })
      ).then(res => {
        this.categories.splice(this.categories.findIndex(v => v.id === res.id), 1, res);
      });
    },
    onClickRecommend(row) {
      row = JSON.parse(JSON.stringify(row));
      row.toptime = row.toptime === 0 ? parseInt(Date.now() / 1000) : 0;
      rpc(
        'StoreCategoryService.UpdateCategory',
        M('CategoryWithTokenRequest', {
          token: M('Token', { token: this.token }),
          category: M('Category', row)
        })
      ).then(res => {
        this.categories.splice(this.categories.findIndex(v => v.id === res.id), 1, res);
      });
    },

    onSearch() {
      rpc(
        'StoreCategoryService.GetCategoryList',
        M('CategoryListQueryRequest', {
          ...this.query,
          token: M('Token', { token: this.token })
        })
      ).then(res => {
        this.categories = res.categorylistList;
      });
    }
  }
};
</script>

<style scoped>
.el-icon-star-on {
  margin-bottom: 0;
  display: none;
}
.el-icon-star-on.show {
  display: block;
}
.el-table__row:hover .el-icon-star-on {
  cursor: pointer;
  display: block;
}

.product-group .el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 90px;
}

.product-group .category-wrapp {
  display: flex;
  align-items: center;
}

.product-group .el-upload.el-upload--picture-card {
  margin-bottom: 0 !important;
}

.product-group .el-upload-list--picture-card .el-upload-list__item {
  width: 80px;
  height: 80px;
  margin: 0;
}

.product-group .el-upload-list__item.is-success .el-upload-list__item-status-label {
  opacity: 0;
}

.product-group .upload-img {
  width: 80px;
  height: 80px;
  position: relative;
}

.product-group .upload-img img {
  width: 80px;
  height: 80px;
}

.product-group .upload-img:hover .upload-img_button {
  display: block;
}

.product-group .upload-img_button {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 80px;
  height: 80px;
  background-color: rgba(0, 0, 0, 0.4);
  text-align: center;
  line-height: 80px;
  color: #fff;
  cursor: pointer;
}
</style>
